import React, { createElement, useRef } from 'react';
import { Select } from '@alifd/next';
import request from '@/utils/request';
const UniqueCodeFilter = ({ onChange, name, fieldName, dict: uniqueCodeArray, }) => {
    const uniqueCodeMapRef = useRef(new Map());
    const [dataSource, setDataSource] = React.useState([]);
    const uniqueCode = uniqueCodeArray?.[uniqueCodeArray?.length - 1];
    const queryList = async (uniqueCode) => {
        const { content = [] } = await request.get('/api/process/field/summary', {
            params: { type: uniqueCode },
        });
        const dataSource = content.map(({ id, name }) => ({
            name,
            id,
        }));
        uniqueCodeMapRef.current.set(uniqueCode, dataSource);
        localStorage.setItem('uniqueCodeMap', JSON.stringify(Array.from(uniqueCodeMapRef.current.entries())));
        setDataSource(dataSource);
    };
    React.useEffect(() => {
        const dictMap = new Map(JSON.parse(localStorage.getItem('uniqueCodeMap')));
        uniqueCodeMapRef.current = dictMap;
        if (dictMap.size === 0) {
            queryList(uniqueCode);
        }
        else {
            const foundCache = uniqueCodeMapRef.current.get(uniqueCode);
            if (foundCache) {
                setDataSource(foundCache);
            }
            else {
                queryList(uniqueCode);
            }
        }
    }, [uniqueCode]);
    const __onChange = (value) => {
        const filterValue = Array.isArray(value) ? value : [value];
        const joinStr = filterValue.join(',');
        onChange({
            operator: 'in',
            dataType: 'stringArray',
            value: joinStr,
            name,
            fieldName,
        });
    };
    return (createElement(Select, { onChange: (value) => __onChange(value), dataSource: dataSource?.map(({ name: label, id: value }) => ({ label, value })), style: { width: '100%' }, hasClear: true, mode: "multiple", showSearch: true }));
};
export default UniqueCodeFilter;
